import { ButtonController } from '@/game/prefabs/GeneralUI/Buttons/ButtonController';

/* START OF COMPILED CODE */

export default class DefaultConfirmButton_m
  extends Phaser.GameObjects.Container
{
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // buttonGuidance
    const buttonGuidance = scene.add.image(
      0,
      0,
      'default-button-confirm-guidance',
    );
    buttonGuidance.scaleX = 2;
    buttonGuidance.scaleY = 2;
    buttonGuidance.alpha = 0;
    buttonGuidance.alphaTopLeft = 0;
    buttonGuidance.alphaTopRight = 0;
    buttonGuidance.alphaBottomLeft = 0;
    buttonGuidance.alphaBottomRight = 0;
    this.add(buttonGuidance);

    // buttonBacking
    const buttonBacking = scene.add.image(0, 0, 'default-button-confirm_m');
    buttonBacking.scaleX = 2;
    buttonBacking.scaleY = 2;
    this.add(buttonBacking);

    // buttonLabel
    const buttonLabel = scene.add.bitmapText(0, 0, 'Aronui', 'Submit');
    buttonLabel.setOrigin(0.5, 0.5);
    buttonLabel.tintTopLeft = 15130076;
    buttonLabel.tintTopRight = 15130076;
    buttonLabel.tintBottomLeft = 15130076;
    buttonLabel.tintBottomRight = 15130076;
    buttonLabel.text = 'Submit';
    buttonLabel.fontSize = -20;
    this.add(buttonLabel);

    this.buttonGuidance = buttonGuidance;
    this.buttonBacking = buttonBacking;
    this.buttonLabel = buttonLabel;
    // awake handler
    this.scene.events.once('scene-awake', () => this.awake());

    /* START-USER-CTR-CODE */
    this._controller = new ButtonController({
      buttonBacking,
      buttonLabel,
      defaultTexture: 'default-button-confirm_m',
      hoverTexture: 'default-button-confirm_m-hover',
      submitTexture: 'default-button-confirm_m',
      disabledTexture: 'default-button-disabled_m',
      buttonGuidance: this.buttonGuidance,
    });
    /* END-USER-CTR-CODE */
  }

  private buttonGuidance: Phaser.GameObjects.Image;
  public buttonBacking: Phaser.GameObjects.Image;
  public buttonLabel: Phaser.GameObjects.BitmapText;
  public buttonText: string = '';

  /* START-USER-CODE */

  _controller: ButtonController;
  get controller() {
    return this._controller;
  }

  awake() {
    const { buttonBacking, buttonLabel } = this;

    buttonLabel.setText(this.buttonText);

    return { button: buttonBacking, text: buttonLabel };
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
